import React, { Suspense } from 'react';
import { RouteComponentProps } from '@reach/router';
import { Helmet } from 'react-helmet-async';
import { EventTrackingPage } from '#core/Tracking';
import ErrorBoundary from '#coreComponents/ErrorBoundary';
import Loading from '#coreComponents/Loading';
import EventTrackingPageView from '#core/Tracking/components/EventTrackingPageView';

interface PublicRouteProps extends RouteComponentProps {
  layout?: React.FC<{}>;
  component: React.ComponentType<RouteComponentProps>;
  default?: boolean;
  path?: string;
  errorBoundaryId: string;
  trackingPageGroup: string;
  trackingPageName: string;
  pageTitle: string;
}

/**
 * This component exists solely as a way to keep the API the same between
 * setting public and private routes.
 */
const PublicRoute: React.FC<PublicRouteProps> = ({
  layout: Layout = React.Fragment,
  component: Component,
  path,
  errorBoundaryId,
  trackingPageGroup,
  trackingPageName,
  pageTitle,
}) => (
  <EventTrackingPage pageGroup={trackingPageGroup} page={trackingPageName}>
    <EventTrackingPageView />
    <Helmet title={pageTitle} />
    <ErrorBoundary id={errorBoundaryId} showDetailedErrorScreen>
      <Layout>
        <Suspense fallback={<Loading showLogo={true} />}>
          <Component path={path} />
        </Suspense>
      </Layout>
    </ErrorBoundary>
  </EventTrackingPage>
);

export default PublicRoute;
